import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class VersionCheckService {
  private baseUri = '/version.json';

  constructor(private _httpClient: HttpClient) { }

  public loadCurrentVersion(): Observable<string> {
    const headers = new HttpHeaders({
      // eslint-disable-next-line @typescript-eslint/naming-convention
      'Cache-Control': 'no-cache',
      'Pragma': 'no-cache'
    });
    const url = `${this.baseUri}?t=${Date.now()}`;
    return this._httpClient
      .get<{ version: string }>(url, { headers })
      .pipe(
        map(response => response.version),
        catchError(error => {
          return of(''); 
        })
      );
  }
}
